import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import Row from "@amzn/meridian/row";
import Input from "@amzn/meridian/input";
import Button from "@amzn/meridian/button";

function ReadOnlyPPCapacityRow({
  ppc,
  selectedNode,
  handleEditClick,
  handleDeleteClick,
}) {
  return (
    <Table spacing="small">
      <TableRow>
        <TableCell width={100}>
          <Input value={selectedNode} />
        </TableCell>
        <TableCell width={200}>
          <Input value={ppc.process_path} />
        </TableCell>
        <TableCell width={150}>
          <Input value={ppc.size} />
        </TableCell>
        <TableCell width={120}>
          <Input value={ppc.capacity} />
        </TableCell>
        <TableCell>
          <Row>
            <Button minWidth={70} onClick={(event) => handleDeleteClick(ppc)}>
              Delete
            </Button>
            <Button minWidth={70} onClick={(event) => handleEditClick(ppc)}>
              Edit
            </Button>
          </Row>
        </TableCell>
      </TableRow>
    </Table>
  );
}

export default ReadOnlyPPCapacityRow;
